import { Component } from "@angular/core";

@Component({
  selector: "app-teams3-content",
  templateUrl: "teams3-content.component.html",
})
export class Teams3ContentComponent {}
